'use client';

import { ServiceModules, type ServiceModulesContent } from '../components';

const PRODUCT_ENGINEERING_SERVICE_CONTENT: ServiceModulesContent = {
  layout: {
    nextLink: '/ip',
    hoverTextColor: 'text-at',
    logoColor: 'text-at',
  },
  hero: {
    backgroundColor: 'bg-navy',
    backgroundImage: '/images/services/ip_waves.jpg',
    headingStatement: 'Crafting your next favorite product',
    headingStatementLines: ['Crafting\u00A0your', 'next\u00A0favorite', 'product'],
    heading: 'Product + Engineering',
    headingLargeText:
      'Companies bring us their big ideas and thorny problems. We transform them into ridiculously great products people love.',
    headingSmallText:
      'We’re not an agency, and we’re not a big engineering firm. We’re a true partner, with a handful of superbly talented, fiercely dedicated people. And we’re ready to embed with your internal team for however long you need us, taking ideas from pitch to prototype and beyond.',
    imageTopOffset: 576,
  },
  teamProof: {
    text: 'We’ve developed and launched products that help people work smarter, communicate more effectively, and improve quality of life.',
  },
  whatWeDo: {
    boldTitle: 'From whiteboard to launch and beyond',
    textParagraphs: [
      'We’re a team of founders and builders who know that each company and project is unique. We’ll get to know your business, your vision, and your unique challenges, then get to work bringing your ideas to life.',
    ],
    ctaText: 'Let’s create something great',
    ctaLink: 'mailto:hello@all-turtles.com?subject=Product%20and%20Engineering%20inquiry',
    rightColumnItems: [
      {
        heading: 'Product Ideation',
        paragraph:
          'You’ve identified a problem, and have an idea about the solution. We can help transform those insights into a clear, approachable user experience that amplifies your mission and your strengths. We do it every day for early-stage startups and big companies like PwC, Rakuten, and Bose.',
      },
      {
        heading: 'Product Design',
        paragraph:
          'Sometimes the idea exists but the potential is uncertain. Using thoughtful interactions and logical content design, we can develop a prototype to see how much is really there, taking that burden off your team.',
      },
      {
        heading: 'Front-end engineering',
        paragraph:
          'From beautiful consumer-facing or B2B websites to lightweight apps, our engineers excel at building user experiences that make new ideas feel approachable and engaging.',
      },
      {
        heading: 'Meaningful AI',
        paragraph:
          'A thoughtful approach to AI is just one of many tools in our problem-solving kit. We use AI to streamline tasks, spark ideas and action, or help you navigate complexity. These low-risk, high-reward approaches produce more accurate, actionable results than just bolting on another generic chatbot.',
      },
    ],
  },
  whatMakesUsUnique: {
    points: [
      {
        boldPhrase: 'Humans who care about humans',
        description:
          'We have strong feelings about what we do. And we only take on projects that excite us, help others do something great, or solve a real problem in the world. We don’t do things because we can, but because we should.',
      },
      {
        boldPhrase: 'Your dream collaborators',
        description:
          'Once we’re signed onto a project, we’ll jump in immediately. Every All Turtles employee cares about understanding the problem, getting to know the people, and finding a sustainable solution that’s a win for everyone.',
      },
      {
        boldPhrase: 'Our approach to AI',
        description:
          'In an age of hype and vague promises, we’re deliberate and keep our focus on what real people really need. That means finding practical ways AI can help humans do the things they do best: thinking, communicating, and solving problems.',
      },
    ],
  },
  allTurtlesInAction: {
    backgroundColor: 'bg-navy',
    backgroundImage: '/images/services/product_carrot.png',
    mobileBackgroundImage: '/images/services/product_carrot.png',
    title: 'Creating better fertility outcomes with Carrot Sprints',
    paragraphs: [
      [
        {
          type: 'text',
          value:
            'The fastest growing cause of infertility and high-risk pregnancies is metabolic dysfunction, linked to factors like diet, movement, sleep, and stress management. Recognizing a gap in how their members tackled these underlying health issues, ',
        },
        {
          type: 'link',
          href: 'https://all-turtles.com/carrot',
          text: 'Carrot Fertility',
        },
        {
          type: 'text',
          value:
            ' partnered with All Turtles to create Sprints, a digital platform focused on hyperpersonalized habit-building.',
        },
      ],
      'Our deep collaboration led to an app that blends Carrot’s vision and medical expertise with All Turtles’ strengths in product development, content design, and rapid prototyping. Sprints uses thoughtfully implemented AI to generate helpful daily prompts tailored to each person’s unique interests and needs. But it’s also supported by a human care team and presented with a focus on usability and positive engagement. It’s a prime example of our commitment to solving real-world problems in a simple, practical way.',
    ],
    testimonialPhoto: '/images/services/product_asima.png',
    testimonialPhotoAlt: 'Asima Ahmad MD MPH FACOG, Co-founder and Chief Medical Officer, Carrot Fertility',
    testimonialQuote:
      "One-size-fits-all strategies built on misaligned incentives simply don't work. Sprints is about addressing root causes, creating wins for members, customers, and providers alike.",
    testimonialPerson: 'Asima Ahmad MD MPH FACOG',
    testimonialTitle: 'Co-founder and Chief Medical Officer, Carrot Fertility',
  },
};


export const ServicePage = () => {
  return <ServiceModules content={PRODUCT_ENGINEERING_SERVICE_CONTENT} />;
};
